import { User, UserActions } from '../types/redux'

type actionTypes =
    { type: UserActions.SIGN_IN; payload: User } |
    { type: UserActions.SIGN_OUT; payload: undefined } |
    { type: UserActions.CHANGE_IS_MFA_ENABLED; payload: boolean }

export function userReducer(
	state : User = { nick: '', privilege: '', uuid: '', isSlim: false, isMFAEnabled: false },
	action: actionTypes
) : User {
	switch (action.type) {
		case UserActions.SIGN_IN: {
			return action.payload
		}
		case UserActions.SIGN_OUT: {
			return { nick: '', privilege: '', uuid: '', isSlim: false, isMFAEnabled: false }
		}
		case UserActions.CHANGE_IS_MFA_ENABLED: {
			return {
			    ...state,
				isMFAEnabled: action.payload
			}
		}
	}
	return state
}
